export interface ContactDetails {
  email: string;
  adminEmail: string;
  number: string;
  address: string;
  companyName: string;
  companyRegistration: string;
  informationOfficer: string;
  privacyLastUpdate: string;
  termsLastUpdate: string;
}

export const Paths = {
  home_page: "/",
  user_account_page: "/user-account",
  providers_page: "/providers",
} as const;

export const contactInformation: ContactDetails = {
  email: "support@servisu.co.za",
  adminEmail: "admin@servisu.co.za",
  number: "+27678679119",
  address: "Protea Glen Extension 11, Soweto, 1819",
  companyName: "Servisu Technologies (Pty) Ltd",
  companyRegistration: "2026/503669/07",
  informationOfficer: "Information Officer",
  privacyLastUpdate: "July 2026",
  termsLastUpdate: "July 2026",
};

export default contactInformation;
